import { ConnectionWrapper } from "~lib/ConnectionProvider";
import { Connection, SyncStage } from "~shared/Connection";

export class LobbyConnection extends ConnectionWrapper {
  constructor(base: Connection) {
    super(base);
  }

  registerStage(): SyncStage {
    return SyncStage.REGISTER_LOBBY;
  }
}
